import { styled } from "@mui/system"
import { Box, Typography } from "@mui/material"

export const Wrapper = styled(Box)({
  backgroundColor: "var(--white)",
  display: "flex",
  flexDirection: "column",
  borderRadius: "12px",
  padding: "32px",
  gap: 16,
})

export const HeaderWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: 8,
})

export const Header = styled(Typography)({
  fontSize: '24px',
  fontWeight: 700,
  color: '#111',
  lineHeight: "normal",
})

export const Subheader = styled(Typography)({
  color: "var(--brand-default-color)",
  fontWeight: 400,
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: "0.25px",
})
export const DataGridWrapper = styled(Box)({
  width: "99%",
})
